export default {
  'menu.welcome': 'Welcome',
  'menu.home': 'Home',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',

  'menu.admin': 'Admin',
  'menu.admin.checklist': 'Checklist',
  'menu.admin.sourceTransaction': 'Source Transaction',
  
  // ==================== Menu Groups ====================
  
  // Business Group
  'menu.business': 'Business',
  'menu.business.sourceTransaction': 'Source Transaction',
  'menu.business.inspectionRequestCoordinator': 'Inspection Request',
  'menu.business.inspectionRequestInspector': 'Inspection List',
  'menu.business.inspectionResult': 'Inspection Result',
  'menu.business.inspectionInline': 'Inspection Inline',
  
  // Setting Group
  'menu.setting': 'Setting',
  'menu.setting.checklist': 'Checklist',
  'menu.setting.defectList': 'Defect List',
  'menu.setting.qcDefinition': 'QC Definition',
  'menu.setting.mapping': 'Mapping',
  
  // List Group
  'menu.list': 'List',
  'menu.list.defectGroup': 'Defect Group',
  'menu.list.defectAction': 'Defect Action',
  'menu.list.defectReason': 'Defect Reason',
  'menu.list.defect': 'Defect',
  'menu.list.defectConversion': 'Defect Conversion',
  
  // Report Group
  'menu.report': 'Report',
  'menu.report.reportTemplate': 'Report Template',
  'menu.report.reportDocs': 'Report Docs',

  // ==================== Report Docs Page ====================
  'pages.reportDocs.templateDesign.title': 'Template Design Guide',
  'pages.reportDocs.templateDesign.description':
    'Detailed guide on how to design report templates and use placeholders for Inspection Result reports.',
  'pages.reportDocs.view': 'View',
  'pages.reportDocs.hide': 'Hide',
  'pages.reportDocs.placeholder': 'Select a document from the list to view its content.',

  // ==================== Inspection Result Page ====================
  'pages.inspectionResult.sourceTransactionCode': 'Source Transaction',
  
  // ==================== Legacy Menu Items (Keep for backward compatibility) ====================
  'menu.sourceTransaction': 'Source Transaction',
  'menu.inspectionRequestCoordinator': 'Inspection Request',
  'menu.inspectionRequestInspector': 'Inspection List',
  'menu.inspectionResult': 'Inspection Result',
  'menu.inspectionInline': 'Inspection Inline',
  'menu.checklist': 'Checklist',
  'menu.defectList': 'Defect List',
  'menu.qcDefinition': 'QC Definition',
  'menu.mapping': 'Mapping',
  'menu.defectGroup': 'Defect Group',
  'menu.defectAction': 'Defect Action',
  'menu.defectReason': 'Defect Reason',
  'menu.defect': 'Defect',
  'menu.defectConversion': 'Defect Conversion',
  'menu.reportTemplate': 'Report Template',
  'menu.reportDocs': 'Report Docs',
};
